import { usePwa } from '../pwa/pwaContext';

export const usePwaInstall = () => {
  const { canInstall, isIos, isStandalone, promptInstall } = usePwa();

  return {
    canInstall,
    isIos,
    isStandalone,
    promptInstall,
    canOfferInstall: !isStandalone && (canInstall || isIos)
  };
};
